export const CalenderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99976 12C1.99976 8.22876 1.99976 6.34315 3.17133 5.17157C4.3429 4 6.22852 4 9.99976 4H13.9998C17.771 4 19.6566 4 20.8282 5.17157C21.9998 6.34315 21.9998 8.22876 21.9998 12V14C21.9998 17.7712 21.9998 19.6569 20.8282 20.8284C19.6566 22 17.771 22 13.9998 22H9.99976C6.22852 22 4.3429 22 3.17133 20.8284C1.99976 19.6569 1.99976 17.7712 1.99976 14V12Z"
        stroke="#2F66F4"
        strokeWidth="1.5"
      />
      <path
        d="M6.99976 4V2.5"
        stroke="#2F66F4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.9998 4V2.5"
        stroke="#2F66F4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.49976 9H21.4998"
        stroke="#2F66F4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17.9998 17C17.9998 17.5523 17.552 18 16.9998 18C16.4475 18 15.9998 17.5523 15.9998 17C15.9998 16.4477 16.4475 16 16.9998 16C17.552 16 17.9998 16.4477 17.9998 17Z"
        fill="#2F66F4"
      />
      <path
        d="M17.9998 13C17.9998 13.5523 17.552 14 16.9998 14C16.4475 14 15.9998 13.5523 15.9998 13C15.9998 12.4477 16.4475 12 16.9998 12C17.552 12 17.9998 12.4477 17.9998 13Z"
        fill="#2F66F4"
      />
      <path
        d="M12.9998 17C12.9998 17.5523 12.552 18 11.9998 18C11.4475 18 10.9998 17.5523 10.9998 17C10.9998 16.4477 11.4475 16 11.9998 16C12.552 16 12.9998 16.4477 12.9998 17Z"
        fill="#2F66F4"
      />
      <path
        d="M12.9998 13C12.9998 13.5523 12.552 14 11.9998 14C11.4475 14 10.9998 13.5523 10.9998 13C10.9998 12.4477 11.4475 12 11.9998 12C12.552 12 12.9998 12.4477 12.9998 13Z"
        fill="#2F66F4"
      />
      <path
        d="M7.99976 17C7.99976 17.5523 7.55204 18 6.99976 18C6.44747 18 5.99976 17.5523 5.99976 17C5.99976 16.4477 6.44747 16 6.99976 16C7.55204 16 7.99976 16.4477 7.99976 17Z"
        fill="#2F66F4"
      />
      <path
        d="M7.99976 13C7.99976 13.5523 7.55204 14 6.99976 14C6.44747 14 5.99976 13.5523 5.99976 13C5.99976 12.4477 6.44747 12 6.99976 12C7.55204 12 7.99976 12.4477 7.99976 13Z"
        fill="#2F66F4"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99976 10.1433C3.99976 5.64588 7.58148 2 11.9998 2C16.418 2 19.9998 5.64588 19.9998 10.1433C19.9998 14.6055 17.4464 19.8124 13.4627 21.6744C12.534 22.1085 11.4655 22.1085 10.5368 21.6744C6.55308 19.8124 3.99976 14.6055 3.99976 10.1433Z"
        stroke="#2F66F4"
        strokeWidth="1.5"
      />
      <circle cx="11.9998" cy="10" r="3" stroke="#2F66F4" strokeWidth="1.5" />
    </svg>
  );
};

export function CloseDrawerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
    >
      <path
        fill="rgba(128, 128, 132, 1)"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10"
        opacity={0.5}
      ></path>
      <path
        fill="rgba(128, 128, 132, 1)"
        d="M8.97 8.97a.75.75 0 0 1 1.06 0L12 10.94l1.97-1.97a.75.75 0 1 1 1.06 1.06L13.06 12l1.97 1.97a.75.75 0 0 1-1.06 1.06L12 13.06l-1.97 1.97a.75.75 0 0 1-1.06-1.06L10.94 12l-1.97-1.97a.75.75 0 0 1 0-1.06"
      ></path>
    </svg>
  );
}
